import React, {useEffect, useState} from 'react';
import EditorFrame from '../EditorFrame';
import styles from './styles.module.scss';

const EditorPreview = ({
                       imageSrc,
                       onConfirm,
                       onReject,
                     }) => {
  const [image, setImage] = useState(null);

  useEffect(() => {
    setImage(imageSrc);
  }, [imageSrc]);

  const handleConfirm = () => {
    onConfirm({modifiedImage: image});
  };

  return (
    <div className={styles.previewContainer}>
      <div className={styles.modalApiImage}>
        {image && (
          <EditorFrame
            imageSrc={image}
            onChange={setImage}
          />
        )}
      </div>
      <div className={styles.modalButtons}>
        <button
          type="button"
          className={styles.buttonCancel}
          onClick={onReject}
        >
          <span>ביטול</span>
        </button>
        <button
          type="button"
          className={styles.buttonSubmit}
          onClick={handleConfirm}
        >
          <span>אשר והוסף לשומה</span>
        </button>
      </div>
    </div>
  );
};

export default EditorPreview;